import { EdgeLoadEffectiveTimeBlocksRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadEffectiveTimeBlocks } from '@/shared/domain'

export function makeLoadEffectiveTimeBlocks(): LoadEffectiveTimeBlocks {
  return new EdgeLoadEffectiveTimeBlocksRepository(makeSupabaseEdgeHttpClient()).execute
}
